import axios from "axios";
import { API_BASE_URL } from "../../../../constants";
import { checkAnsweredFor, guardSession } from "../../../auth/v2/sessionBinding";
import { errorMessage } from "./coachOnboardingModel";

// Coach onboarding V2 API. The wizard keeps to the account it opened with
// through the shared session binding (auth/v2/sessionBinding), and submits
// through the shared onboarding endpoints (guarded by the same binding).

export { SESSION_CHANGED, bindSession, sessionChanged } from "../../../auth/v2/sessionBinding";
export { completeOnboarding, requestTeam } from "../../../ForAthletes/v2/onboarding/onboardingV2Services";
export { executeFetchPlan as fetchTeamsForPlan, fetchCerebroCompetitions as searchLeagues } from "../../../ForBusiness/Cacheshare/services/cacheShareServices";

const call = async (method, data) => {
  // Throws (code SESSION_CHANGED) before sending for another account.
  const token = guardSession();
  let res;
  try {
    res = await axios({ method, url: `${API_BASE_URL}/coach/onboarding/`, data, headers: { Authorization: `Bearer ${token}` } });
  } catch (e) {
    const err = new Error(errorMessage(e, "Something went wrong. Try again."));
    err.status = e.response?.status;
    throw err;
  }
  checkAnsweredFor(res.data);
  return res.data;
};

// -> {email, firstName, lastName, onboardingCompleted, progress {step, draft, updatedAt}, verification {status, code}, team}
export const getCoachOnboarding = () => call("get");
// Without a draft the saved one is kept (the verification screen reopening the wizard).
export const saveCoachProgress = (step, draft) => call("patch", { progress: draft === undefined ? { step } : { step, draft } });
